import React from "react";

function ButtonFullComponent(props) {

    return (
        <div className="mb-3">
            <button type="button" className={`${props.customClass} btn custom-btn w-100`}
                id={props.id}
                onClick={props.handleClick}
                disabled={props.disabled || props.loading}>
                {props.loading ? (
                    <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span className="sr-only">Executando...</span>
                    </>
                ) : (
                    <>
                        {props.icon_style ? (
                            <>   <i className={props.icon_style} style={{ paddingRight: '10px' }}></i> {props.text}</>
                        ) : (props.text)}
                    </>
                )}
            </button>
        </div>
    );
}

export default ButtonFullComponent;








